import { useMutation } from 'react-relay';

import { checkLookPageMutation } from '@/__generated__/checkLookPageMutation.graphql';
import { checkLookPage } from '@/graphql/mutation/taxRefund/checkLookPage';

export const useCheckLookPage = () => {
  const [commit, isInFlight] = useMutation<checkLookPageMutation>(checkLookPage);
  return { commit, isInFlight };
};
